import api from './api';

const supplierOrdersService = {
    getAll: async () => {
        const response = await api.get('/api/admin/supplier-orders');
        return response.data;
    },

    getAllBySupplier: async (supplierId) => {
        // If backend supports filtering, or client side filter
        // Currently backend index returns all. 
        // Ideally we add ?supplierId= to backend. 
        // For now get all and filter or assumes usage is global list.
        const response = await api.get('/api/admin/supplier-orders');
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/api/admin/supplier-orders/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/api/admin/supplier-orders', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/api/admin/supplier-orders/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        await api.delete(`/api/admin/supplier-orders/${id}`);
    },

    // Items
    addItem: async (orderId, itemData) => {
        const response = await api.post(`/api/admin/supplier-orders/${orderId}/items`, itemData);
        return response.data;
    },

    removeItem: async (orderId, itemId) => {
        // Note: API route is /api/admin/supplier-orders/items/:itemId
        const response = await api.delete(`/api/admin/supplier-orders/items/${itemId}`);
        return response.data;
    },

    downloadPdf: async (id) => {
        const response = await api.get(`/api/admin/supplier-orders/${id}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    },

    // Helper to calculate total from local state if needed (or rely on backend)
};

export default supplierOrdersService;
